import React from "react";

// Image
import profilePhoto from "../../../Assets/images/profile.png";
import heart from "../../../Assets/images/heart.png";
import message from "../../../Assets/images/message.png";
import send from "../../../Assets/images/send.png";

const Post = ({ name, img, tag, title, link }) => {
  return (
    <div>
      <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
                #About
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://media-exp1.licdn.com/dms/image/C4D03AQF5IZRnrufEHg/profile-displayphoto-shrink_800_800/0/1599735110684?e=2147483647&v=beta&t=u-GZ4I1s4K-5-E2l86MiZOqQIvEdE-fDK_-BumDz7bg"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">Joel Deon Dsouza</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
              I am a Self-Experienced Web-developer, adept at bringing forth
              expertise in design, installation, testing, and maintenance of
              Web-application. Proficient in an assortment of technologies,
              including JavaScript, NodeJs, React, React Native, Swift IOS, and
              MongoDB Atlas Server. I believe empathy is a key factor in
              emotional intelligence which makes it an important skill in any
              workplace.
            </p>
            {/* !Added parameter */}
            {/* {link ? (
              <a
                href={link}
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  color: "#2192FF",
                }}
              >
                Click here
              </a>
            ) : null} */}
          </div>
          {/* title */}
        </div>
      </div>

      {/* Post 2 */}

      <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
                #Github Account
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://beecrowd.io/wp-content/uploads/2022/08/Beecrowd-Agosto-6-02-larger.png"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">Github</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
              Few of my projects are available on this GitHub.
            </p>
            <a
              href="https://github.com/JoelDeonDsouza"
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#2192FF",
              }}
            >
              Click here
            </a>
          </div>
          {/* title */}
        </div>
      </div>

      {/* Post 3 */}

      <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
              #Programming-language
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://apostube.com/wp-content/uploads/2022/06/js1-720x530.jpg"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">JavaScript Skills</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
              Understanding of Asynchronous code, Expert of design tasks, Understanding of networking and HTTP-based APIs, Comfortable with at least two JS frameworks and have experience with it.
            </p>
          </div>
          {/* title */}
        </div>
      </div>

       {/* Post 4 */}

       <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
             #JavaScript-Library
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://wallpaperaccess.com/full/3949076.jpg"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">React Skills</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
              React fundamentals (JSX, Virtual DOM, Native, Node.js), Redux, Tailwind.
            </p>
          </div>
          {/* title */}
        </div>
      </div>

      {/* Post 5 */}

      <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
             #Server-side Programming-language
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://wallpaperaccess.com/full/3909251.jpg"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">Node.js Skills</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
              MongoDB, Express, Package management, Security.
            </p>
          </div>
          {/* title */}
        </div>
      </div>

       {/* Post 6 */}

       <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
            #TypeScript Programming-language
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Typescript.svg/600px-Typescript.svg.png?20220718100136"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">Typescript Skills</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
             Client side interfaces, function overloading etc.
            </p>
          </div>
          {/* title */}
        </div>
      </div>
   

   {/* Post 7 */}

   <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
            #Connect-mail
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://play-lh.googleusercontent.com/KSuaRLiI_FlDP8cM4MzJ23ml3og5Hxb9AapaGTMZ2GgR103mvJ3AAnoOFz1yheeQBBI"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">Gmail connect</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
             Get in Touch!
            </p>
            <a
              href="mailto:jdeondsouza@gmail.com"
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#2192FF",
              }}
            >
              Click here
            </a>
          </div>
          {/* title */}
        </div>
      </div>

      {/* Post 8 */}

   <div className="border rounded-lg my-3">
        <div className="flex items-center p-3">
          <div className="flex items-center w-full">
            <div className="h-8 w-8 mr-3">
              <img src={profilePhoto} alt="profile" className="rounded-full" />
            </div>
            <div>
              <p className="font-semibold text-sm">Joel Deon Dsouza</p>
              <p
                className="text-sm"
                style={{
                  fontWeight: "800",
                  color: "#EF5B0C",
                  textTransform: "uppercase",
                  fontSize: "13px",
                }}
              >
            #Twitter
              </p>
            </div>
          </div>
        </div>
        {/* post-img */}
        <div className="">
          <img
            src="https://static.dezeen.com/uploads/2012/06/dezeen_twitter-bird.gif"
            alt="postImg"
          />
        </div>
        {/* post-img */}
        <div className="m-3">
          {/* BTN */}
          <div className="flex space-x-4">
            <div className="btn">
              <img src={heart} alt="heart" />
            </div>
            <div className="btn">
              <img src={message} alt="message" />
            </div>
            <div className="btn">
              <img src={send} alt="send" />
            </div>
          </div>
          {/* BTN */}
          {/* title */}
          <div className="mt-2">
            <p className="customFont">Twitter connect</p>
            <p
              className="mt-1"
              style={{ fontSize: "14px", fontWeight: "500", color: "#3C4048" }}
            >
             Connect for fun!
            </p>
            <a
              href="https://twitter.com/JoelDeonDsouza"
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#2192FF",
              }}
            >
              Click here
            </a>
          </div>
          {/* title */}
        </div>
      </div>
    </div>
  );
};

export default Post;
